import { httpClient } from "../../util/api";

export const fnNewOrder = async (params) => await httpClient.post('/culqi/nuevoPedido', params);
export const fnGetUrlVoucherPDF = async (params) => await httpClient.post('/get-url-voucher-pdf', params);
// export const listDepreciation = async (year, period) => axios.get(`/api/V1/asset/depreciation?year=${year}&period=${period}`);

// export const fnGetUrlVoucherPDF = async (purchaseOrderNumber) => httpClient.get(`/get-url-voucher-pdf?purchaseOrderNumber=${purchaseOrderNumber}`);
